// Func = limiting Scope for this file
var lastScrollTop = 0;
(function(){

	$(document).ready(function () {
		//Call function with browser is resized.
		$(window).resize(function (event) {
			// resizeWindow();
		});
		// resizeWindow();

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			// scrollDown();
		});

		// WEDDINGS FORM BUDGET MIN VALUE
		/*const weddingsBudgetInput = document.querySelector('#form_id-316 input[name="budget"]');
		if (weddingsBudgetInput !== null) {
			weddingsBudgetInput.setAttribute('value',3200);
			weddingsBudgetInput.setAttribute('min',3200);
			weddingsBudgetInput.setAttribute('step',100);
		}*/

		// METTINGS FORM BUDGET MIN VALUE
		/*const mettingsBudgetInput = document.querySelector('#form_id-315 input[name="budget"]');
		if (mettingsBudgetInput !== null) {
			mettingsBudgetInput.setAttribute('value',300);
			mettingsBudgetInput.setAttribute('min',300);
			mettingsBudgetInput.setAttribute('step',50);
		}*/

		// VENUES OPEN BOTTOM FORM ON MODAL
		document.querySelectorAll('.js-formFancybox').forEach((btn) => {
			btn.addEventListener('click', e => {
				e.preventDefault();
				try {
					const formWrapped = document.querySelector('.js-formFancybox-target').parentNode;
					$.fancybox(formWrapped, {
						padding: 0,
						afterClose: _ => {
							formWrapped.removeAttribute('style');
						}
					});
				} catch (err) {
					console.warn(err, '.js-formFancybox-target not found.');
				}
			});
		});

		// WRAP TEXT MODULE TABLES
		document.querySelectorAll('.text-modules table').forEach(table => {
			const tableWrapper = document.createElement('div');
			tableWrapper.classList.add('text-modules_table');
			table.parentNode.insertBefore(tableWrapper, table);
			tableWrapper.appendChild(table);
		});

		// QUADS LIST "READ MORE" TOGGLE CONTENT
		$('.js-toggleContent').click(function(e){
			let currentBtn = this;
			let currentTarget = $.attr(currentBtn,'href');
			e.preventDefault();
			$(currentTarget).stop().slideToggle('fast', function(){
				let currentBtn_text = $(currentTarget).is(':visible') ? 'Read less' : 'Read more';
				$(currentBtn).text(currentBtn_text);
			})
		});

		// RESTAURANT MENUS FILTER
		document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.restMenus_item').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});

		//Trigger Click Popup Restaurant
		if(document.body.classList.contains('lido')){
			var hashPopup = window.location.hash;
			var finalHash = hashPopup.replace('#','');
			document.getElementById(finalHash).click();
		}

		// SPA FILTER
		document.querySelectorAll('.spaMod_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				$('.spaMod .listQuads_slider').slick('unslick');

				document.querySelectorAll('.spaMod_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				if (btn.dataset.tag === 'services') {
					document.querySelectorAll('.spaMod .accordion').forEach(accor => {
						accor.classList.add('active');
					});
					document.querySelectorAll('.spaMod .listQuads_item').forEach(quad => {
						quad.classList.remove('active');
					});
				} else {
					document.querySelectorAll('.spaMod .accordion').forEach(accor => {
						accor.classList.remove('active');
					});
					document.querySelectorAll('.spaMod .listQuads_item').forEach(quad => {
						quad.classList.remove('active');
						if ( btn.dataset.tag === quad.dataset.tag ) {
							quad.classList.add('active');
						}
					});
				}

				$('.spaMod .listQuads_slider').slick();
			});

			if (i === 1) btn.click();
		});

		// ACCORDION TOGGLE
		$('.accordion_title').click(function(){
			$(this).closest('.accordion_list').find('.accordion_body').stop().slideUp('fast', function(){
				$(this).css('height', 'auto');
				$(this).closest('.accordion_item').toggleClass('active', $(this).is(':visible'));
			});

			$(this).next('.accordion_body').stop().slideToggle('fast', function(){
				$(this).css('height', 'auto');
				$(this).closest('.accordion_item').toggleClass('active', $(this).is(':visible'));
			});
		});

		// SPECIALS FILTER
		document.querySelectorAll('.specials_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				document.querySelectorAll('.specials_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.specials_item').forEach(special => {
					special.classList.remove('active');
					if ( btn.dataset.tag === 'all' ||  btn.dataset.tag === special.dataset.tag ) {
						special.classList.add('active');
					}
				});
			});

			if (i === 0) btn.click();
		});

		// ACCOMMODATIONS FILTER
		document.querySelectorAll('.rooms_filter li').forEach((btn, i) => {
			btn.addEventListener('click', _ => {
				$('.rooms_slider').slick('unslick');

				document.querySelectorAll('.rooms_filter li').forEach(b => b.classList.remove('active'));
				btn.classList.add('active');

				document.querySelectorAll('.rooms_item').forEach(room => {
					room.classList.remove('active');
					if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
						room.classList.add('active');
					}
				});

				$('.rooms_slider').slick();
			});

			if (i === 0) btn.click();
		});


		// BOOKING TOGGLE
		document.querySelectorAll('.js-booking-toggle').forEach(btn => {
			btn.addEventListener('click', e => {
				let bookingModule = document.querySelector(e.currentTarget.getAttribute('href'));

				e.preventDefault();
				if(bookingModule.classList.contains('fixed')){
					bookingModule.classList.toggle('active');
					e.currentTarget.classList.toggle('active');
				} else{
					$('html,body').stop().animate({ scrollTop: getElementOffset(bookingModule).top - document.querySelector('.bookingModule_wrapper').offsetHeight }, 500, function(){
						document.querySelector('.header').classList.remove('up');
						document.querySelector('.header').classList.add('down');
					});
				}
			});
		});

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){
			let d1=$.datepicker.parseDate(VISIBLE_FORMAT,$('#CheckIn').val());
			let d2=$.datepicker.parseDate(VISIBLE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		// CHECKIN - CHECKOUT no required
		document.getElementById('CheckIn').removeAttribute('required');
		document.getElementById('CheckOut').removeAttribute('required');

		//Check in and check out datepicker for booking engine
		const VISIBLE_FORMAT = "mm-dd-yy";
		const DATE_FORMAT = ($("#CheckIn--alt").data("format") !== undefined && $("#CheckIn--alt").data("format")) ? $("#CheckIn--alt").data("format") : "yy-mm-dd";
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: VISIBLE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 1);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );

				// UPDATE ALT INPUTS
				$( "#CheckIn--alt" ).val( $.datepicker.formatDate(DATE_FORMAT, getDate) );
				$( "#CheckOut--alt" ).val( $.datepicker.formatDate(DATE_FORMAT, newDate) );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: VISIBLE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );

				// UPDATE ALT INPUT
				let getDate = $(this).datepicker('getDate');
				$( "#CheckOut--alt" ).val( $.datepicker.formatDate(DATE_FORMAT, getDate) );
			}
		});

		$('#CheckIn').keyup( _ => $('#CheckIn--alt').val( $.datepicker.formatDate('yy-mm-dd', $('#CheckIn').datepicker('getDate')) ) );
		$('#CheckOut').keyup( _ => $('#CheckOut--alt').val( $.datepicker.formatDate('yy-mm-dd', $('#CheckOut').datepicker('getDate')) ) );

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}

	for(let el of document.getElementsByClassName('bookingModule')) {
		const homepageOffset = document.getElementById('home') ? 0 : document.querySelector('.header').offsetHeight;
		if(st > 80){
			if ( st > getElementOffset(el).top - homepageOffset ) {
				el.classList.add('fixed');
				if (st > lastScrollTop){
					el.classList.add('down');
					el.classList.remove('up');
				} else{
					el.classList.add('up');
					el.classList.remove('down');
				}
			} else {
				el.classList.remove('fixed');
				el.classList.remove('up');
				el.classList.remove('down');
			}
		}
		el.classList.remove('active');
	}

	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function getElementOffset(el) {
	const rect = el.getBoundingClientRect();

	return {
		top: rect.top + window.pageYOffset,
		left: rect.left + window.pageXOffset,
	};
}